export default __webpack_public_path__ + "static/media/8-hk_hiking.ae2351d9.jpg";